
import { defineComponent, computed } from 'vue'
import type { CapitalDistribution } from '@/types/arkOne'
import Nodata from '@/components/page/nodata.vue'

const __default__ = defineComponent({
  name: 'CapitalDistribution',
  components: {
    Nodata
  },
  props: {
    distribution: {
      type: Object as () => CapitalDistribution,
      required: true
    },
    // 主题：'dark' | 'light'
    theme: {
      type: String,
      default: 'dark'
    },
    // 语言支持：'zh-Hans' 简体中文，'zh-Hant' 繁体中文
    language: {
      type: String,
      default: 'zh-Hans'
    }
  },
  setup(props) {
    // 语言相关
    const isTraditional = computed(() => props.language === 'zh-Hant')
    
    console.log('[CapitalDistribution] props.language:', props.language)
    console.log('[CapitalDistribution] isTraditional:', isTraditional.value)
    
    // 翻译函数
    const t = (key: string): string => {
      const translations: Record<string, Record<string, string>> = {
        'capitalDistribution': {
          'title': isTraditional.value ? '資金佔比' : '资金占比',
          'stocks': isTraditional.value ? '股票' : '股票',
          'etf': isTraditional.value ? 'ETF' : 'ETF',
          'cash': isTraditional.value ? '現金' : '现金',
          'other': isTraditional.value ? '其他' : '其他',
          'noData': isTraditional.value ? '資金佔比' : '资金占比'
        }
      }
      
      const [category, subKey] = key.split('.')
      const result = translations[category]?.[subKey] || key
      console.log(`[CapitalDistribution] t('${key}') = '${result}'`)
      return result
    }

    // 判断是否有数据（至少有一个非零值）
    const hasData = computed(() => {
      return props.distribution.stocks !== 0 || 
             props.distribution.etf !== 0 || 
             props.distribution.cash !== 0 || 
             props.distribution.other !== 0
    })

    const formatValue = (value: number): string => {
      return `${Math.abs(value).toFixed(2)}%`
    }

    return {
      hasData,
      formatValue,
      t
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "59b561ab": (_ctx.theme === "light" ? "#ffffff" : "#1A1D2F"),
  "f5c5aa7c": (_ctx.theme === "light" ? "#000000" : "#ffffff"),
  "1033addb": (_ctx.theme === "light" ? "#f7f9fc" : "rgba(12, 18, 36, 0.9)"),
  "cb4eba5c": (_ctx.theme === "light" ? "#e4e7ed" : "rgba(255, 255, 255, 0.06)"),
  "3b7114bc": (_ctx.theme === "light" ? "#666666" : "#cccccc")
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__